import {
  PeergroupMenuMemberPopup,
  PeergroupMenuMemberPopupStateProps,
  PeergroupMenuMemberPopupDispatchProps,
  PeergroupMenuMemberPopupOwnProps,
} from 'components/features/pfm/PeergroupMenuPopup/PeergroupMenuMemberPopup'
import { State } from 'interfaces/state'
import { hidePeergroupPopupActionCreator, registerPeergroupPopupTimeoutActionCreator } from 'actions/sidebarActions'
import { connectOptionally, createPositiveRendererProps, NO_RENDER, OptionalRendererProps } from 'tangle-shared'
import { memberInfoSelector } from 'selectors/globalSelectors'
import { peergroupPopupTimeoutIdSelector } from 'selectors/peergroupSelectors'

const mapStateToProps = (state: State, _ownProps: PeergroupMenuMemberPopupOwnProps): OptionalRendererProps<PeergroupMenuMemberPopupStateProps> => {
  const member = memberInfoSelector(state)

  if (!member) {
    return NO_RENDER()
  }

  return createPositiveRendererProps({
    member,
    hideTimeoutId: peergroupPopupTimeoutIdSelector(state),
  })
}

const mapDispatchToProps: PeergroupMenuMemberPopupDispatchProps = {
  onHidePopup: () => hidePeergroupPopupActionCreator('member'),
  onRegisterHideTimeout: registerPeergroupPopupTimeoutActionCreator,
}

export const PeergroupMenuMemberPopupContainer = connectOptionally<
  PeergroupMenuMemberPopupStateProps,
  PeergroupMenuMemberPopupDispatchProps,
  PeergroupMenuMemberPopupOwnProps
>(mapStateToProps, mapDispatchToProps)(PeergroupMenuMemberPopup)
